import { alpha, Button, styled, TableCell } from '@mui/material'
import { DataGrid, GridToolbarContainer } from '@mui/x-data-grid'

export const StyledTableCell = styled(TableCell)(() => ({
  paddingTop: '0px',
  paddingBottom: '0px',
  component: 'th',
  scope: 'row',
  padding: 0,
}))

export const StyledGridToolbarContainer = styled(GridToolbarContainer)(() => ({
  padding: '5px 5px 6px 5px',
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
}))

export const CustomToolbarButton = styled(Button)(() => ({
  backgroundColor: 'transparent',
  variant: 'text',
  color: 'primary',
  size: 'small',
  padding: '6px 12px',
  whiteSpace: 'pre-wrap',
  fontWeight: 'bold',
  fontSize: '16px',
}))

const ODD_OPACITY = 0.1

export const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  '--DataGrid-rowBorderColor': theme.palette.divider,
  '& .MuiDataGrid-row': {
    backgroundColor: theme.palette.background.default,
    borderColor: theme.palette.divider,
    '&:nth-of-type(odd)': {
      backgroundColor: alpha(theme.palette.background.default, ODD_OPACITY),
    },
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  '& .MuiDataGrid-columnsContainer': {
    backgroundColor: theme.palette.background.default,
  },
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: theme.palette.background.default,
  },
  '& .MuiDataGrid-columnHeader--withRightBorder, & .MuiDataGrid-cell--withRightBorder': {
    borderRightColor: theme.palette.divider,
  },
  '& .MuiDataGrid-columnHeader:focus': {
    outline: 'none',
    backgroundColor: theme.palette.action.selected,
  },
  '& .MuiDataGrid-columnHeader:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 'bold',
  },
  '& .MuiDataGrid-cell': {
    borderColor: theme.palette.divider,
  },
  '& .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  '& .MuiDataGrid-row.Mui-selected': {
    backgroundColor: theme.palette.action.selected,
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
    },
  },
  '& .MuiDataGrid-cell:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '& .MuiDataGrid-cell--textLeft': {
    textAlign: 'left',
  },
  '& .MuiDataGrid-cell--textCenter': {
    textAlign: 'center',
  },
  '& .MuiDataGrid-cell--textRight': {
    textAlign: 'right',
  },
  '& .MuiDataGrid-cell--alignLeft': {
    justifyContent: 'flex-start',
  },
  '& .MuiDataGrid-cell--alignCenter': {
    justifyContent: 'center',
  },
  '& .MuiDataGrid-cell--alignRight': {
    justifyContent: 'flex-end',
  },
  '& .MuiDataGrid-cell--withRenderer': {
    alignItems: 'center',
  },
  '& .MuiDataGrid-cell--editing': {
    backgroundColor: 'transparent',
  },
  '& .MuiDataGrid-cell--editing .MuiDataGrid-cellFocusRing': {
    display: 'none',
  },
  '& .MuiDataGrid-cell--editing .MuiDataGrid-cellInner': {
    padding: 0,
  },
  '& .MuiDataGrid-cell--editing .MuiDataGrid-editInputCell': {
    padding: theme.spacing(1),
  },
  '& .MuiDataGrid-cell--editing .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  '& .MuiDataGrid-cell--editing .MuiDataGrid-cell:focus-within': {
    outline: 'auto',
  },
}))

export const StyledGridOverlay = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
}))
